import {formatRoute} from 'react-router-named-routes';
import AbstractNotification from "./AbstractNotification";
import {
  accept,
  decline,
  miss
} from "../../../../screens/message/actions/messageAction";
import {hash} from "../../../actions";
import {ROUTER_MESSAGE_SENIOR} from "../../../constants/routers";

export default class TextMessageNotification extends AbstractNotification {

  title = __("send a message");
  icon = 'fa-envelope';

  constructor(notification, sender) {
    super(notification, sender);
    this.message = notification.text;
  }

  accept(dispatch, history) {
    dispatch(accept(this))
      .then(() => {
        const seniorHash = hash(this.sender.prof_id);

        history.push(formatRoute(ROUTER_MESSAGE_SENIOR, {seniorHash}));
      });
  }

  decline(dispatch) {
    dispatch(miss(this.room));
    dispatch(decline(this));
  }

  timeOut(dispatch) {
    this.decline(dispatch)
  }
}
